import { Verification } from "modules/resellers";

const VerificationPage = () => {
  return <Verification />;
};

export default VerificationPage;
